import { Typography, Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import { StyleConstants, Styles } from '../Styles';
import '../App.css';
import GreenLightIcon from './GreenLightIcon';
import BrownLightIcon from './BrownLightIcon';
import RedLightIcon from './RedLightIcon';

const LightStatusStack = () => {
    return (
        <Stack direction="column" sx={{ color: StyleConstants.fontColor }}>
            <Typography sx={{ ...Styles.contentFont2 }}>
                Status:
            </Typography>

            <Stack direction="row" sx={{ marginLeft: '8px', ...Styles.contentFont2, alignContent: 'center', alignItems: 'center', gap: 1 }}>
                <RedLightIcon />
                <Box>
                    Fault (Level I)
                </Box>
            </Stack>

            <Stack direction="row" sx={{ marginLeft: '8px', ...Styles.contentFont2, alignContent: 'center', alignItems: 'center', gap: 1 }}>
                <BrownLightIcon />
                <Box>
                    Fault (Level II)
                </Box>
            </Stack>

            <Stack direction="row" sx={{ marginLeft: '8px', ...Styles.contentFont2, alignContent: 'center', alignItems: 'center', gap: 1 }}>
                <GreenLightIcon />
                <Box>
                    Operating
                </Box>
            </Stack>
        </Stack>
    );
};

export default LightStatusStack;